import React from 'react';

import { Stack } from '@atlaskit/primitives/compiled';
import Skeleton from '@atlaskit/skeleton';

export const RulePreviewSkeleton = () => {
	return (
		<Stack space="space.150" testId="rule-preview-skeleton">
			<>
				<Skeleton width="150px" height="16px" isShimmering />
				<Skeleton width="150px" height="16px" isShimmering />
			</>
		</Stack>
	);
};
